import { useTranslation } from 'react-i18next';
import {
  Table,
  TableBody,
  TableCell,
  TableCellHead,
  TableHead,
  TableRow,
} from '~/ui/Table';
import dayjs from 'dayjs';

import styles from './UserPromotionFormTable.module.scss';
import i18n from '~/i18n';
import { Link } from 'react-router-dom';

interface IPromotionTableProps {
  data: {
    points: number;
    created_at: string;
    promo_loyalty: { name: string };
    manual_action: boolean | null;
    by_user: {
      full_name: string;
      id: number;
    };
  }[];
  sort: { field: string; direction: string };
  setSort: ({ field, direction }: { field: string; direction: string }) => void;
}

interface IPromotionLabelProps {
  manualAction: boolean | null;
  promoName: string | undefined;
  points: number;
  user: {
    full_name: string;
    id: number;
  };
}

const PromotionLabel = ({
  manualAction,
  promoName,
  points,
  user,
}: IPromotionLabelProps) => {
  if (manualAction === null) {
    return <span> {promoName || ''} </span>;
  }

  if (manualAction === true) {
    return points < 0 ? (
      <>
        {i18n.t('manual_writeoff')}
        {' / '}
        <Link to={`/user/${user.id}`} className={styles.link}>
          {user.full_name}
        </Link>
      </>
    ) : (
      <>
        {i18n.t('manual_accrual')}
        {' / '}
        <Link to={`/user/${user.id}`} className={styles.link}>
          {user.full_name}
        </Link>
      </>
    );
  }

  return <span> {i18n.t('manual_delete')} </span>;
};

const PointQuantity = ({ point }: { point: number }) => {
  const isPositive = point > 0;

  return (
    <div className={isPositive ? styles.positive : styles.negative}>
      {isPositive
        ? `+${point} ${i18n.t('points')}`
        : `${point} ${i18n.t('points')}`}
    </div>
  );
};

export const UserPromotionFormTable = ({
  data,
  sort,
  setSort,
}: IPromotionTableProps) => {
  const { t } = useTranslation();

  return (
    <Table>
      <TableHead sort={sort} setSort={setSort}>
        <TableCellHead field="created_at">{t('date')}</TableCellHead>
        <TableCellHead field="points">{t('write_off_accrual')}</TableCellHead>
        <TableCellHead field="points">{t('promotion')}</TableCellHead>
      </TableHead>
      <TableBody>
        {data.map((item, idx) => (
          <TableRow key={idx}>
            <TableCell>{dayjs(item.created_at).format('DD.MM.YYYY')}</TableCell>
            <TableCell>
              <PointQuantity point={item.points} />
            </TableCell>
            <TableCell>
              <PromotionLabel
                manualAction={item.manual_action}
                promoName={item.promo_loyalty?.name}
                points={item.points}
                user={item.by_user}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
